import BatteryListModal from './battery-age-list-modal.connect'

export default BatteryListModal
